<template>
	<div class="after-info">
		<!-- 导航 -->
		<van-nav-bar
		  title="售后订单详情"
		  left-text="返回"
		  left-arrow
		  @click-left="goBack"
		/>
		<!-- 详情信息 -->
		<div class="info-block">
			<!-- 商品详情 -->
			<div class="goods-info">
				<van-image v-if="goodsInfo.length > 0" class="goods-image" width="100px" height="100px" fit="contain" :src="imgUrl + goodsInfo[0].goods_image"/>
				<div v-if="goodsInfo.length > 0" class="goods-detail-wapper">
					<p class="goods-name">{{goodsInfo[0].goods_name}}</p>
					<p class="good-detail-item"><span>市场价:</span>￥{{goodsInfo[0].goods_price}}</p>
					<p class="good-detail-item"><span>购买价:</span>￥{{goodsInfo[0].goods_pay_price}}</p>
					<p class="good-detail-item"><span>数量:</span>￥{{goodsInfo[0].goods_num}}</p>
				</div>
			</div>
			<!-- 售后详情 -->
			<div class="refund-info">
				<div class="refund-title">售后信息</div>
				<div class="refund-item">
					<span class="refund-item-label">处理结果：</span>
					<span class="refund-item-content"></span>
				</div>
				<div class="refund-item">
					<span class="refund-item-label">处理状态：</span>
					<span class="refund-item-content"></span>
				</div>
				<div class="refund-item">
					<span class="refund-item-label">订单号：</span>
					<span class="refund-item-content"></span>
				</div>
				<div class="refund-item">
					<span class="refund-item-label">买家会员名：</span>
					<span class="refund-item-content"></span>
				</div>
				<div class="refund-item">
					<span class="refund-item-label">退单号：</span>
					<span class="refund-item-content">{{refundInfo.order_sn}}</span>
				</div>
				<div class="refund-item">
					<span class="refund-item-label">售后类型：</span>
					<span class="refund-item-content"></span>
				</div>
				<div class="refund-item">
					<span class="refund-item-label">是否退款：</span>
					<span class="refund-item-content"></span>
				</div>
				<div class="refund-item">
					<span class="refund-item-label">当前物流状态：</span>
					<span class="refund-item-content"></span>
				</div>
				<div class="refund-item">
					<span class="refund-item-label">买家留言：</span>
					<span class="refund-item-content"></span>
				</div>
				<div class="refund-item">
					<span class="refund-item-label">处理回复：</span>
					<span class="refund-item-content"></span>
				</div>
				<div class="refund-item">
					<span class="refund-item-label">售后原因：</span>
					<span class="refund-item-content">{{refundInfo.reason_info}}</span>
				</div>
			</div>
			<!-- 收货详情 -->
			<div class="refund-info">
				<div class="refund-title">收货信息</div>
				<div class="refund-item">
					<span class="refund-item-label">收货人：</span>
					<span class="refund-item-content">{{goodsBasicInfo.buyer_name}}</span>
				</div>
				<div class="refund-item">
					<span class="refund-item-label">收货地址：</span>
					<span class="refund-item-content">{{receiveList.address}}</span>
				</div>
				<div class="refund-item">
					<span class="refund-item-label">手机号码：</span>
					<span class="refund-item-content">{{receiveList.phone}}</span>
				</div>
				<div class="refund-item">
					<span class="refund-item-label">座机号码：</span>
					<span class="refund-item-content">{{receiveList.mob_phone}}</span>
				</div>
				<div class="refund-item">
					<span class="refund-item-label">支付方式：</span>
					<span class="refund-item-content"></span>
				</div>
				<div class="refund-item">
					<span class="refund-item-label">下单日期：</span>
					<span class="refund-item-content"></span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getAfterInfo } from '../../../api/sale'
export default {
  name: 'AfterInfo',
	components: {
	},
  data () {
    return {
			// 订单基本信息
			goodsBasicInfo: {},
			// 订单详情
			goodsInfo: [],
			// 售后详情
			refundInfo: [],
			// 收货信息
			receiveList: {}
    }
  },
	methods: {
		// 返回上一页
		goBack () {
			this.$router.go(-1)
		},
		// 跳转到售后的详情页
		goAfterInfo () {
			this.$router.push({ name: 'AfterInfo' })
		}
	},
	created () {
		getAfterInfo(this.$route.params.afterId).then(res => {
			// 订单基本信息
			this.goodsBasicInfo = res.result.order
			// 订单详情
			this.goodsInfo = res.result.order.goods_list
			// 售后详情
			this.refundInfo = res.result.refund
			// 收货信息
			this.receiveList = res.result.order.order_common.reciver_info
			// console.log(res.result)
		}).catch(error=>{
			// name
		})
	}
}
</script>

<style lang="scss" scoped>
.after-info {
	font-size: 14px;
	.goods-info {
		display: flex;
		align-items: center;
		box-shadow: 0 0 5px #E0E0E0;
		margin: 10px;
		border: 1px solid #E0E0E0;
		padding: 10px;
		.goods-image {
			margin-right: 10px;
			flex-shrink: 0;
		}
		.goods-detail-wapper {
			.goods-name {
				font-weight: bold;
				margin-bottom: 10px;
			}
			.good-detail-item {
				color: #303133;
				font-size: 12px;
				margin-bottom: 10px;
			}
		}
	}
	.refund-info {
		box-shadow: 0 0 5px #E0E0E0;
		margin: 10px;
		border: 1px solid #E0E0E0;
		padding: 10px;
		.refund-title {
			padding-bottom: 5px;
			margin-bottom: 5px;
			border-bottom: 1px solid #EEEEEE;
		}
		.refund-item {
			display: flex;
			justify-content: space-between;
			margin-bottom: 10px;
			.refund-item-label {
				color: #636060;
			}
		}
	}
}
.after-info   ::v-deep.van-nav-bar {
	background-color: #e93b3d;
	color: white;
	.van-icon-arrow-left, .van-nav-bar__text, .van-nav-bar__title {
		color: white;
	}
}
</style>
